.tooltip {
  border-radius: var(--border-radius__sm);
  padding: var(--space__md) var(--space__md);
  outline: none;
  max-inline-size: 300px;
  display: flex;
  font-size: var(--font-size__sm);
  font-weight: var(--font-weight__regular);
  line-height: var(--line-height__2xs);
}

.light {
  background-color: var(--color__gray-100);
  color: var(--color__gray-800);
  border: 1px solid var(--color__gray-300);
}

.dark {
  color: var(--color__white);
  background-color: var(--color__gray-800);
  border: 2px solid var(--color__gray-800);
}

/*
 * The popover's surface (`popover/Popover.module.css`), so a passive explanation looks like the
 * popover without its focus trap: white, a `gray-300` hairline, the popover's `xs` radius, `lg`
 * inset and placement-facing shadow, and room for a short structured explanation.
 * There is no hover version of the popover itself: it is modal (focus trap, page lock), so a
 * passive explanation takes this look on the tooltip's hover, focus and tap behaviour instead. The type inside
 * comes from the content's own `Text`, so it can take the body step rather than the tooltip's 12px.
 * Its arrow is the popover's too (`TooltipArrow`).
 */
.white {
  padding: var(--space__lg);
  max-inline-size: 22rem;
  border-radius: var(--border-radius__xs);
  background-color: var(--color__white);
  color: var(--color__gray-800);
  border: 1px solid var(--color__gray-300);
}

.white[data-placement='top'] {
  box-shadow: 0 1px 4px rgba(0 0 0 / 0.1);
}

.white[data-placement='bottom'] {
  box-shadow: 0 -1px 4px rgba(0 0 0 / 0.1);
}

.white[data-placement='right'] {
  box-shadow: -1px 0 4px rgba(0 0 0 / 0.1);
}

.white[data-placement='left'] {
  box-shadow: 1px 0 4px rgba(0 0 0 / 0.1);
}

.tooltip:where([data-component='tooltip']) {
  /* fixes FF gap */
  transform: translate3d(0, 0, 0);
}

.tooltip[data-entering] {
  animation: show 200ms;
}

.tooltip[data-exiting] {
  animation: show 200ms reverse ease-in;
}

@keyframes show {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}
